import { render, staticRenderFns } from "./chakantupian.vue?vue&type=template&id=4f63a976&scoped=true"
import script from "./chakantupian.vue?vue&type=script&lang=js"
export * from "./chakantupian.vue?vue&type=script&lang=js"
import style0 from "./chakantupian.vue?vue&type=style&index=0&id=4f63a976&prod&scoped=true&lang=css"
import style1 from "./chakantupian.vue?vue&type=style&index=1&id=4f63a976&prod&lang=css"
import style2 from "./chakantupian.vue?vue&type=style&index=2&id=4f63a976&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f63a976",
  null
  
)

export default component.exports